export class GaslessResolver {
    constructor(providers) {
        this.providers = providers || [];
    }
    supportsNetwork(network) {
        return this.providers.some(p => p.supportsNetwork(network));
    }
    async signGaslessDeposit(params) {
        const provider = this.providers.find(p => p.supportsNetwork(params.network));
        if (!provider) {
            const error = `No gasless provider found for network: ${params.network.name}`;
            console.warn(error);
            throw error;
        }
        return provider.signGaslessDeposit(params);
    }
}
